import { ANIMATION_DURATION } from '@/constants/register.contants'
import { Box, Button, Grow, List, ListItem, ListItemText, Paper, TextField, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { IconArrowUp } from '@tabler/icons-react'
import React, { useState } from 'react'

export const InterestForm: React.FC<InterestFormProps> = ({ interests: initialInterests, onFormSubmit }) => {
  const [interests, setInterests] = useState<Interest[]>(initialInterests)
  const [additionalThoughts, setAdditionalThoughts] = useState('')
  const [motivationErrorMessage, setMotivationErrorMessage] = useState('')

  const handleInterestSelection = (id: string) => {
    setInterests(
      interests.map((interest) => (interest.id === id ? { ...interest, selected: !interest.selected } : interest)),
    )
  }

  const validateForm = () => {
    let valid = true
    if (interests.every((interest) => !interest.selected)) {
      setMotivationErrorMessage('Please select at least one interest.')
      valid = false
    } else {
      setMotivationErrorMessage('')
    }

    return valid
  }

  const handleSubmit = () => {
    if (!validateForm()) return
    onFormSubmit(interests, additionalThoughts)
  }

  return (
    <Grow in={true} timeout={ANIMATION_DURATION}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          width: '100%',
          position: 'relative',
        }}
      >
        <List sx={{ mb: 2 }} dense disablePadding>
          {interests.map((interest) => (
            <ListItem
              key={interest.id}
              onClick={() => handleInterestSelection(interest.id)}
              sx={{
                cursor: 'pointer',
                bgcolor: interest.selected ? (theme) => alpha(theme.palette.info.light, 0.1) : 'transparent',
                borderRadius: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                },
                py: 1,
                transition: 'background-color 0.3s ease',
                my: 1,
              }}
            >
              <ListItemText
                primary={interest.label}
                sx={{
                  '& .MuiListItemText-primary': {
                    color: 'text.primary',
                  },
                }}
              />
            </ListItem>
          ))}
        </List>

        {motivationErrorMessage && (
          <Typography variant="body2" color="error" sx={{ mt: 1, ml: 2, mb: 1 }}>
            {motivationErrorMessage}
          </Typography>
        )}

        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
            Here are my thoughts
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Type your message here (if any)"
            value={additionalThoughts}
            onChange={(e) => setAdditionalThoughts(e.target.value)}
            variant="standard"
            slotProps={{
              input: {
                disableUnderline: true,
              },
            }}
            sx={{
              '& .MuiInputBase-root': {
                fontSize: '1rem',
                color: 'text.primary',
              },
              '& .MuiInputBase-input': {
                p: 0,
              },
            }}
          />
        </Box>

        <Button
          variant="outlined"
          onClick={handleSubmit}
          sx={{
            position: 'absolute',
            right: 10,
            bottom: 10,
            borderRadius: 12,
            minWidth: 35,
            borderWidth: 2,
            p: 1,
          }}
        >
          <IconArrowUp size={18} stroke={4} />
        </Button>
      </Paper>
    </Grow>
  )
}
